import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M23.38,28.77H8.62L1.25,16,8.62,3.23H23.38L30.75,16Zm-14-1.3H22.62L29.25,16,22.62,4.53H9.38L2.75,16Z' }),
  React.createElement('path', { d: 'M13.06,21.81A4,4,0,0,1,9,17.48v-3a4.09,4.09,0,1,1,8.17,0v3A4,4,0,0,1,13.06,21.81Zm0-1.72a2.32,2.32,0,0,0,2.35-2.61v-3a2.36,2.36,0,1,0-4.69,0v3A2.32,2.32,0,0,0,13.06,20.09Z' }),
  React.createElement('path', { d: 'M20.35,12.11H18.08l1.33-1.73h2.68V21.65H20.35Z' })
));